import { Link } from "react-router";

import { useBrandName } from "@/api/hooks/tenant";
import { Logo } from "@/components/common/logo";
import { ThemeToggle } from "@/components/theme/theme-toggle";

import { AppSwitcher } from "./app-switcher";
import { MobileNav } from "./mobile-nav";
import { APP_HOME } from "./nav-config";
import { SearchButton, SearchIconButton } from "./search-button";
import { UserMenu } from "./user-menu";

interface TopBarProps {
  onOpenSearch: () => void;
  navOpen: boolean;
  onNavOpenChange: (open: boolean) => void;
}

export function TopBar({ onOpenSearch, navOpen, onNavOpenChange }: TopBarProps) {
  const brand = useBrandName();
  return (
    <header
      data-app-titlebar
      className="sticky top-0 z-20 flex h-15 items-center gap-3 border-b bg-background/85 px-4 backdrop-blur-md sm:px-6 lg:px-10"
    >
      <div className="flex min-w-0 flex-1 items-center gap-2">
        <MobileNav open={navOpen} onOpenChange={onNavOpenChange} />
        <Link
          to={APP_HOME}
          aria-label={`${brand} home`}
          className="mr-2 flex rounded-md outline-none focus-visible:ring-[3px] focus-visible:ring-ring/40 lg:hidden"
        >
          <Logo size="sm" />
        </Link>
        <SearchButton onClick={onOpenSearch} className="hidden sm:flex" />
      </div>
      <div className="flex items-center gap-1">
        <SearchIconButton onClick={onOpenSearch} className="sm:hidden" />
        <ThemeToggle />
        <AppSwitcher />
        <UserMenu />
      </div>
    </header>
  );
}
